export default __webpack_public_path__ + "static/media/apps.6894d9fc.png";